export default __webpack_public_path__ + "static/media/bharat-rubber.8ddf91c3.webp";